import { isDesktop } from 'common/utils';
// plan to use for limitDigits, changing plans
export const onlyNumbers = value => {
  if (value) {
    return value.replace(/[^\d|.]/g, '');
  }
  return '';
};

// limit digits for numbers
export const limitDigits = (value, degit, decimal) => {
  if (value) {
    // take care of decimal
    const above0 = value.split('.');
    // remove first 0
    let newvalue = above0.length < 1 ? [value, 0] : above0;
    // actual slice
    newvalue[0] =
      newvalue[0].length > 1
        ? newvalue[0].replace(/^0/, '').slice(0, degit)
        : newvalue[0];
    if (newvalue[1]) {
      newvalue[1] =
        newvalue[1].length > 1 && decimal
          ? newvalue[1].slice(0, decimal)
          : newvalue[1];
    }

    return newvalue.join('.');
  }
  return '';
};

// Allow desktop and mobile to display GPS in different format
export const formatGPS = (value, digit = 6) => {
  // Example format of `value`: "56.38931711023275, -113.16633911426044"
  const [lat, lng] = value.split(' ');
  return isDesktop()
    ? value
    : `${Number.parseFloat(lat).toFixed(digit)}, ${Number.parseFloat(
        lng
      ).toFixed(digit)}`;
};

export const trim = value => (typeof value === 'string' ? value.trim() : value);



// WEBPACK FOOTER //
// ./src/common/normalizers.js